export const stats = [
  { value: "5,200+", label: "Greencards issued" },
  { value: "$15B", label: "in development" },
  { value: "25", label: "Projects" },
  { value: "$3B+", label: "in EB-5 capital" }
];

export const benefits = [
  {
    title: "Economic Impact",
    description: "Drive U.S. job creation."
  },
  {
    title: "Education Access",
    description: "Access top-tier educational facilities for your children."
  },
  {
    title: "Healthcare Benefits",
    description: "Avail of world-class healthcare."
  },
  {
    title: "Permanent Residency",
    description: "Secure a permanent home for your family in the U.S."
  },
  {
    title: "Citizenship Pathway",
    description: "Create a clear path to U.S. citizenship"
  },
  {
    title: "Investment Security",
    description: "Invest in secure, government-approved projects"
  }
];

export const testimonials = [
  {
    image: "https://customer-assets.emergentagent.com/job_fasttrack-visa/artifacts/qbltb57c_faceless_Ultra-realistic_photograph_of_an_Asian_businesswoman_d421b769-2f60-4d76-9dfb-0be5cc4ab744_3.png",
    quote: "We are so excited that our son can now live the life he always dreamed of in the United States.",
    name: "Investor",
    location: "Guangzhou, China",
    project: "Via Mizner project"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_fasttrack-visa/artifacts/qtqhcbr5_faceless_Ultra-realistic_close-up_portrait_of_an_Indian_busin_c80c5225-2fcc-41cf-ae9b-0d482a2b7499_3.png",
    quote: "The impressive track record, professionalism and consistent accessibility provided confidence and security for me and my family.",
    name: "Investor",
    location: "Mumbai, India",
    project: "76 11th Avenue project"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_fasttrack-visa/artifacts/3txw9uri_faceless_Ultra-realistic_photograph_of_an_old_Asian_businessm_04399fa9-ea12-4c17-a4a0-1ee58fe1817d_1.png",
    quote: "My entire family received our green cards and we have now been fully repaid our investment. We thank them for helping us through this process.",
    name: "Investor",
    location: "Guangzhou, China",
    project: "Via Mizner project"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_fasttrack-visa/artifacts/zkirhitu_faceless_Ultra-realistic_portrait_of_an_Indian_man_South_Asia_7daa78e7-cda3-4e6c-9177-37d56c1a5998_2.png",
    quote: "We would recommend their services and projects without hesitation to others following a similar path to ours.",
    name: "Investor",
    location: "Mumbai, India",
    project: "101 Murray project"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_fasttrack-visa/artifacts/w0rfyfgl_faceless_Ultra-realistic_photograph_of_an_old_Asian_businessm_747b4530-ae19-4e17-afe2-4ee8c0d00724_0.png",
    quote: "Yes!! I got the repayment. It is great news we have completed the Visa process. Thank you for your help.",
    name: "Investor",
    location: "Shenzhen, China",
    project: "Via Mizner project"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_fasttrack-visa/artifacts/qfgfg500_faceless_Ultra-realistic_photograph_of_an_Asian_businessman_w_eadefa86-b005-418f-a56d-8f075a79a7a1_0.png",
    quote: "The amazing track record of success gave both my wife and I great confidence.",
    name: "Investor",
    location: "Shanghai, China",
    project: "West 57th project"
  }
];

export const processSteps = [
  {
    icon: "DollarSign",
    title: "Invest $500,000",
    description: "Choose a U.S. Visa project and invest $500,000 in a government approved regional center."
  },
  {
    icon: "CreditCard",
    title: "Receive Greencard",
    description: "Receive your conditional green card in as little as 120 days*. Move to the U.S. with your eligible family members."
  },
  {
    icon: "Home",
    title: "Receive Permanent Residency & Repayment",
    description: "After USCIS and Project requirements have been satisfied, anticipate Permanent U.S. Residency and repayment of investment."
  }
];

export const investmentOptions = [
  {
    icon: "TrendingUp",
    title: "Invest Over Time",
    description: "Tailored investment plans that fit your financial timeline"
  },
  {
    icon: "CheckCircle",
    title: "Investor Loans",
    description: "Financing options to help you meet the necessary investment requirements."
  },
  {
    icon: "Handshake",
    title: "Free Consultation",
    description: "Speak with our experts to understand your options and the process."
  }
];

export const countries = [
  "Afghanistan", "Albania", "Algeria", "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan",
  "Bahrain", "Bangladesh", "Belgium", "Bolivia", "Brazil", "Bulgaria", "Cambodia", "Cameroon",
  "Canada", "Chile", "China", "Colombia", "Costa Rica", "Croatia", "Cyprus", "Czech Republic",
  "Denmark", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Estonia", "Ethiopia",
  "Finland", "France", "Germany", "Ghana", "Greece", "Guatemala", "Hong Kong", "Hungary",
  "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy", "Jamaica", "Japan",
  "Jordan", "Kazakhstan", "Kenya", "Kuwait", "Latvia", "Lebanon", "Lithuania", "Luxembourg",
  "Malaysia", "Mexico", "Morocco", "Nepal", "Netherlands", "New Zealand", "Nigeria", "Norway",
  "Oman", "Pakistan", "Panama", "Peru", "Philippines", "Poland", "Portugal", "Qatar",
  "Romania", "Russia", "Saudi Arabia", "Serbia", "Singapore", "Slovakia", "Slovenia",
  "South Africa", "South Korea", "Spain", "Sri Lanka", "Sweden", "Switzerland", "Taiwan",
  "Thailand", "Turkey", "Ukraine", "United Arab Emirates", "United Kingdom", "Uruguay",
  "Uzbekistan", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"
];
